var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.90001 1.6V3.1H15.1V1.6H16.9V3.1H20.5C21.5494 3.1 22.4 3.95067 22.4 5V9.1V10.9V20.5C22.4 21.5494 21.5494 22.4 20.5 22.4H3.50001C2.45067 22.4 1.60001 21.5494 1.60001 20.5V10.9V9.1V5C1.60001 3.95066 2.45066 3.1 3.50001 3.1H7.10001V1.6H8.90001ZM15.1 4.9V7.4H16.9V4.9H20.5C20.5552 4.9 20.6 4.94476 20.6 5V9.1H3.40001V5C3.40001 4.94477 3.44478 4.9 3.50001 4.9H7.10001V7.4H8.90001V4.9H15.1ZM3.40001 10.9V20.5C3.40001 20.5552 3.44477 20.6 3.50001 20.6H20.5C20.5553 20.6 20.6 20.5552 20.6 20.5V10.9H3.40001Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.72f86a292ca9587a302f0b9423d7c46d.svg";
export { ForwardRef as ReactComponent };